module.exports = __webpack_public_path__ + "img/rank.49e68148.png";